import { useEffect, useRef } from 'react'

import { useAsyncEntity } from '../../../../Entity'
import { OVERVIEW_PAYLOAD_FIELD } from '../../RentalPortalOverview.constants'
import { getMockReportingOverview } from '../../RentalPortalOverview.mocks'

import { getSupersededOverviewRead } from './useRentalPortalOverviewRead.utils'

// TODO: the composite read is served by the mock module until
// `GET /api/v3/rental-portal/reporting/overview/` exists, and §11 declares no
// per-panel error envelope — a feed that failed arrives as an absent block key,
// so a panel retry re-issues the whole composite read.
export function useRentalPortalOverviewRead({ period }) {
  const isReadStartedRef = useRef(false)
  const readIdRef = useRef(0)

  async function getProfileData() {
    readIdRef.current += 1

    const readId = readIdRef.current

    try {
      const response = await getMockReportingOverview({ period })

      return readIdRef.current === readId
        ? response
        : getSupersededOverviewRead()
    } catch (error) {
      if (readIdRef.current !== readId) {
        return getSupersededOverviewRead()
      }

      throw error
    }
  }

  const {
    entityData,
    handleEntityInit,
    handleEntityReload,
    isInitiated,
    isLoading,
    serverError,
  } = useAsyncEntity({ getProfileData })

  useEffect(() => {
    if (isReadStartedRef.current) {
      handleEntityReload()
    }

    isReadStartedRef.current = true
  }, [period])

  return {
    handleReload: handleEntityReload,
    handleRetry: handleEntityInit,
    hasBodyError: Boolean(serverError) && !entityData,
    hasNoScope:
      Boolean(entityData) && !entityData[OVERVIEW_PAYLOAD_FIELD.hasScope],
    hasStaleError: Boolean(serverError) && Boolean(entityData),
    isLoading,
    isRefetching: isLoading && isInitiated,
    overview: entityData,
  }
}
